import { render, staticRenderFns } from "./app-left-right.vue?vue&type=template&id=20b830d1&scoped=true&"
import script from "./app-left-right.vue?vue&type=script&lang=js&"
export * from "./app-left-right.vue?vue&type=script&lang=js&"
import style0 from "./app-left-right.vue?vue&type=style&index=0&id=20b830d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b830d1",
  null
  
)

export default component.exports